module.exports = __webpack_public_path__ + "static/media/ffo_toilette.d0e542bc.jpg";